import { render, staticRenderFns } from "./DraggableImageButtons.vue?vue&type=template&id=2a348378&scoped=true"
import script from "./DraggableImageButtons.vue?vue&type=script&lang=ts"
export * from "./DraggableImageButtons.vue?vue&type=script&lang=ts"
import style0 from "./DraggableImageButtons.vue?vue&type=style&index=0&id=2a348378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a348378",
  null
  
)

/* custom blocks */
import block0 from "./DraggableImageButtons.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports